import http from "../http-common";

class SubjectResponsiblePersonService {
  createSubjectResponsiblePerson(data) {    
      return http.post(`/api/subject_responsible_person`, data);
    }
  getSubjectResponsiblePersons(year,term,exam_type) {
    return http.get(`/api/subject_responsible_person?year=`+year+'&&term='+term+'&&exam_type='+exam_type);
  }
  getSubjectResponsiblePersonByFilter(data) {
    return http.get(`/api/subject_responsible_person/getSubjectResponsiblePersonByFilter?examination_schedule_id=`+data.examination_schedule_id+'&&proctor_id='+data.proctor_id);
  }
  getInstrutorFilter(data) {
    return http.get(`/api/subject_responsible_person/getInstrutorFilter?year=`+data.year+'&&term='+data.term+'&&exam_type='+data.exam_type);
  }
  getSubjectResponsiblePerson(id) {
    return http.get(`/api/subject_responsible_person/`+id);
  }
  updateSubjectResponsiblePerson(id, data) {
    return http.put(`/api/subject_responsible_person/${id}`, data);
  }
}

export default new SubjectResponsiblePersonService();